import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import { AuthenticatedLayout } from '@/layouts'
import { setupGuards } from './guards'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false, title: 'routes.login' },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { requiresAuth: false, title: 'routes.register' },
  },
  {
    path: '/register/pending',
    name: 'RegisterPending',
    component: () => import('@/views/RegisterPendingView.vue'),
    meta: { requiresAuth: false, title: 'routes.registerPending' },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false, title: 'routes.forgotPassword' },
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: () => import('@/views/TermsAndConditionsView.vue'),
    meta: { requiresAuth: false, title: 'routes.terms' },
  },
  {
    path: '/legal-bases',
    name: 'LegalBases',
    component: () => import('@/views/LegalBasesView.vue'),
    meta: { requiresAuth: false, title: 'routes.legalBases' },
  },
  {
    path: '/',
    component: AuthenticatedLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { title: 'routes.dashboard' },
      },
      {
        path: 'challenges',
        name: 'Challenges',
        component: () => import('@/views/ChallengesView.vue'),
        meta: { title: 'routes.challenges' },
      },
      {
        path: 'tickets',
        name: 'TicketStatus',
        component: () => import('@/views/TicketStatusView.vue'),
        meta: { title: 'routes.ticketStatus' },
      },
      {
        path: 'balance',
        name: 'CashBalance',
        component: () => import('@/views/CashBalanceView.vue'),
        meta: { title: 'routes.cashBalance' },
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/ProfileView.vue'),
        meta: { title: 'routes.profile' },
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/NotificationsView.vue'),
        meta: { title: 'routes.notifications' },
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('@/views/PrivacyView.vue'),
        meta: { title: 'routes.privacy' },
      },
      {
        path: 'owner/dashboard',
        name: 'OwnerDashboard',
        component: () => import('@/views/OwnerDashboardView.vue'),
        meta: { requiredRole: 'owner', title: 'routes.ownerDashboard' },
      },
      {
        path: 'owner/employee-approvals',
        name: 'EmployeeApprovals',
        component: () => import('@/views/OwnerEmployeeApprovalsView.vue'),
        meta: { requiredRole: 'owner', title: 'routes.employeeApprovals' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: 'routes.notFound' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { top: 0 }
  },
})

setupGuards(router)

export default router
